import { StandardEvents } from '@shopify/events';

class ProductMatches extends HTMLElement {
  request;
  selection = 0;

  connectedCallback() {
    this.hidden = !this.querySelector('[data-recommended-product]');
    this.querySelectorAll('[data-match-variant]').forEach(card => {
      card.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href);
        if (!url.pathname.includes('/products/')) return;
        url.searchParams.set('variant', card.dataset.matchVariant);
        link.href = url;
      });
    });
    document.addEventListener(StandardEvents.productSelect, this.onSelection);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCart);
    window.addEventListener('pageshow', this.onPageShow);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.productSelect, this.onSelection);
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCart);
    window.removeEventListener('pageshow', this.onPageShow);
    this.request?.abort();
  }

  onSelection = async event => {
    const picker = event.target.closest('variant-picker');
    if (!picker || picker.dataset.productId !== this.dataset.productId) return;
    const selection = ++this.selection;
    this.hidden = true;
    this.request?.abort();
    try {
      const result = await event.promise;
      if (!this.isConnected || selection !== this.selection) return;
      const variant = result.detail?.resource?.id;
      if (!variant) return;
      this.dataset.variantId = String(variant);
      this.refresh();
    } catch {}
  };

  onCart = async event => {
    this.hidden = true;
    try {
      await event.promise;
      this.refresh();
    } catch {}
  };

  onPageShow = event => {
    if (event.persisted) this.refresh();
  };

  refresh = async () => {
    if (!this.isConnected) return;
    this.hidden = true;
    this.request?.abort();
    const request = new AbortController();
    this.request = request;
    const url = new URL(this.dataset.productUrl, location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);
    url.searchParams.set('variant', this.dataset.variantId);
    try {
      const response = await fetch(url, { signal: request.signal, cache: 'no-store' });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = html.querySelector('erten-product-matches');
      if (next && this.isConnected && !request.signal.aborted) this.replaceWith(next);
    } catch {}
  };
}

if (!customElements.get('erten-product-matches')) customElements.define('erten-product-matches', ProductMatches);
